// import psyImages from "../components/utility/psychologicalImageImports";
const vacationChoicesBg = [
  {
    label: "Спокойно убежище в минималистичен спа с мистериозни пещери наблизо.",
    value:
      'A quiet retreat in a minimalist, gray spa with mysterious caves nearby.{"Gray":"3","Black":"2"}',
    // imageUrl: psyImages["vacation/forFormA.png"],
  },
  {
    label: "Спокойен плаж със синкави води и ясно небе.",
    value:
      'A serene beach with azure waters and twilight in the sky.{"Blue":"3","Violet":"2"}',
    // imageUrl: psyImages["vacation/forFormB.png"],
  },
  {
    label: "Гора с високи дървета и планински пътеки.",
    value:
      'A lush green forest with tall green trees and earthy brown paths.{"Green":"3","Brown":"2"}',
    // imageUrl: psyImages["vacation/forFormC.png"],
  },
  {
    label:
      "Шумен град с интензивен нощен живот и слънчеви, открити паркове.",
    value:
      'A bustling city with intense nightlife and sunny, open parks.{"Red":"3","Yellow":"2"}',
    // imageUrl: psyImages["vacation/forFormD.png"],
  },
];

export default vacationChoicesBg;
